import React, { useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
	FaUser,
	FaPhoneAlt,
	FaEnvelope,
	FaMapMarkerAlt,
	FaLanguage,
	FaUserTag,
	FaClock,
	FaMoneyBillWave,
	FaInfoCircle,
	FaBroom,
	FaCheckCircle,
	FaPlus,
	FaTrash,
	FaTools,
	FaCalendarCheck,
} from "react-icons/fa";
import config, { getUserCity } from "../../../config";

const BASE_URL = config.API_BASE_URL || "http://localhost:8000";

const Cleaner = () => {
	const navigate = useNavigate();
	const [activeForm, setActiveForm] = useState("post");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isSearching, setIsSearching] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const [focusedField, setFocusedField] = useState("");

	const categoryKey = "home-services";
	const serviceKey = "house-keeping";

	const areaOptions = config.AREA_OPTIONS || {};
	const selectedCategory = config.SERVICE_CONFIG?.[categoryKey];
	const selectedService =
		config.SERVICE_CONFIG?.[categoryKey]?.services?.[serviceKey];
	const serviceTypes = selectedService?.types || [];

	const serviceLabel = selectedService?.label || "House Keeping";
	const categoryLabel = selectedCategory?.label || "Home Services";

	const [formData, setFormData] = useState({
		username: "",
		mobilenumber: "",
		email: "",
		address: "",
		city: "",
		area: "",
		language: "",
		gender: "",
		duration: "",
		urgency: "",
		preferredworkTime: "",
		additionalNotes: "",
		salaryOffered: "",
		selectedServices: [
			{
				id: 1,
				service_type: "",
				quantity: 1,
			},
		],
	});

	const [searchCriteria, setSearchCriteria] = useState({
		gender: "",
		city: "",
		area: "",
	});

	const availableAreas = useMemo(() => {
		const selected =
			areaOptions[formData.city] || areaOptions[formData.city?.toLowerCase()];
		if (Array.isArray(selected)) return selected;
		if (selected?.areas) return selected.areas;
		return [];
	}, [formData.city, areaOptions]);

	const searchAreas = useMemo(() => {
		const selected =
			areaOptions[searchCriteria.city] || areaOptions[searchCriteria.city?.toLowerCase()];
		if (Array.isArray(selected)) return selected;
		if (selected?.areas) return selected.areas;
		return [];
	}, [searchCriteria.city, areaOptions]);

	const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

	const styles = {
		page: {
			minHeight: "100vh",
			background:
				"linear-gradient(135deg, #f8fbff 0%, #eef4ff 35%, #e9f1ff 70%, #f4f8ff 100%)",
			padding: isMobile ? "16px" : "30px 20px",
			fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
		},
		wrapper: {
			maxWidth: "1440px",
			width: "100%",
			margin: "0 auto",
		},
		hero: {
			background: "linear-gradient(135deg, #0f172a, #1e3a8a, #2563eb)",
			color: "#fff",
			borderRadius: isMobile ? "20px" : "30px",
			padding: isMobile ? "24px 18px" : "36px 40px",
			boxShadow: "0 24px 50px rgba(30, 64, 175, 0.22)",
			marginBottom: "22px",
			position: "relative",
			overflow: "hidden",
		},
		heroBadge: {
			display: "inline-flex",
			alignItems: "center",
			gap: "8px",
			background: "rgba(255,255,255,0.14)",
			border: "1px solid rgba(255,255,255,0.18)",
			padding: "8px 14px",
			borderRadius: "999px",
			fontSize: "12px",
			fontWeight: "800",
			marginBottom: "14px",
			letterSpacing: "0.4px",
		},
		heroTitle: {
			margin: 0,
			fontSize: isMobile ? "1.6rem" : "2.25rem",
			fontWeight: "800",
			lineHeight: 1.2,
		},
		heroText: {
			marginTop: "12px",
			marginBottom: 0,
			color: "rgba(255,255,255,0.92)",
			maxWidth: "860px",
			lineHeight: 1.7,
			fontSize: isMobile ? "14px" : "15px",
		},
		switchWrap: {
			display: "flex",
			gap: "12px",
			flexWrap: "wrap",
			marginBottom: "20px",
		},
		switchBtn: {
			border: "1px solid #d8e3f0",
			borderRadius: "999px",
			padding: isMobile ? "10px 16px" : "12px 20px",
			background: "#ffffff",
			color: "#334155",
			fontSize: "14px",
			fontWeight: "800",
			cursor: "pointer",
			boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
			transition: "all 0.2s ease",
		},
		switchBtnActive: {
			background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
			color: "#fff",
			border: "1px solid #2563eb",
			boxShadow: "0 14px 24px rgba(37, 99, 235, 0.22)",
		},
		formCard: {
			background: "#fff",
			borderRadius: isMobile ? "20px" : "28px",
			border: "1px solid #e6edf8",
			boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
			overflow: "hidden",
			width: "100%",
			maxWidth: "1320px",
			margin: "0 auto",
		},
		formHeader: {
			padding: isMobile ? "20px 18px" : "28px 40px",
			borderBottom: "1px solid #edf2f7",
			background: "linear-gradient(180deg, #ffffff, #f8fbff)",
		},
		formTitle: {
			margin: 0,
			fontSize: isMobile ? "1.25rem" : "1.65rem",
			fontWeight: "800",
			color: "#0f172a",
			lineHeight: 1.25,
		},
		formSub: {
			margin: "8px 0 0 0",
			color: "#64748b",
			fontSize: "14px",
			lineHeight: 1.6,
			maxWidth: "780px",
		},
		body: {
			padding: isMobile ? "18px" : "32px 40px 36px",
		},
		section: {
			marginBottom: "24px",
			padding: isMobile ? "18px" : "24px",
			borderRadius: isMobile ? "16px" : "20px",
			background: "linear-gradient(180deg, #fbfdff, #f7fbff)",
			border: "1px solid #e7eef8",
		},
		sectionTitle: {
			margin: "0 0 16px 0",
			fontSize: "1.08rem",
			fontWeight: "800",
			color: "#0f172a",
			display: "flex",
			alignItems: "center",
			gap: "8px",
		},
		grid: {
			display: "grid",
			gridTemplateColumns: isMobile
				? "1fr"
				: "repeat(auto-fit, minmax(260px, 1fr))",
			gap: "18px",
			alignItems: "start",
		},
		field: {
			display: "flex",
			flexDirection: "column",
			gap: "8px",
		},
		fullWidthField: {
			gridColumn: "1 / -1",
			display: "flex",
			flexDirection: "column",
			gap: "8px",
		},
		label: {
			fontSize: "14px",
			fontWeight: "700",
			color: "#334155",
			display: "flex",
			alignItems: "center",
			gap: "8px",
		},
		input: {
			width: "100%",
			padding: "14px 16px",
			borderRadius: "14px",
			border: "1px solid #d9e3ef",
			fontSize: "15px",
			outline: "none",
			background: "#fff",
			boxSizing: "border-box",
			color: "#0f172a",
			transition: "all 0.2s ease",
		},
		inputFocus: {
			border: "1px solid #2563eb",
			boxShadow: "0 0 0 4px rgba(37, 99, 235, 0.12)",
		},
		select: {
			width: "100%",
			padding: "14px 16px",
			borderRadius: "14px",
			border: "1px solid #d9e3ef",
			fontSize: "15px",
			outline: "none",
			background: "#fff",
			boxSizing: "border-box",
			color: "#0f172a",
			transition: "all 0.2s ease",
		},
		textarea: {
			width: "100%",
			minHeight: "120px",
			padding: "14px 16px",
			borderRadius: "14px",
			border: "1px solid #d9e3ef",
			fontSize: "15px",
			outline: "none",
			background: "#fff",
			boxSizing: "border-box",
			resize: "vertical",
			color: "#0f172a",
			transition: "all 0.2s ease",
		},
		helper: {
			color: "#64748b",
			fontSize: "13px",
			margin: "0 0 4px 0",
			lineHeight: 1.5,
		},
		submitWrap: {
			display: "flex",
			justifyContent: "center",
			marginTop: "28px",
		},
		submitBtn: {
			border: "none",
			borderRadius: "999px",
			background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
			color: "#fff",
			padding: "15px 34px",
			fontSize: "15px",
			fontWeight: "800",
			minWidth: isMobile ? "100%" : "260px",
			boxShadow: "0 14px 26px rgba(37, 99, 235, 0.24)",
			cursor: "pointer",
			transition: "all 0.2s ease",
		},
		successBox: {
			background: "#ecfdf5",
			border: "1px solid #bbf7d0",
			color: "#166534",
			padding: "14px 16px",
			borderRadius: "14px",
			marginBottom: "18px",
			fontWeight: "700",
			display: "flex",
			alignItems: "center",
			gap: "10px",
		},
		disabledField: {
			background: "#f8fafc",
			color: "#94a3b8",
			cursor: "not-allowed",
		},
		serviceCard: {
			background: "#fff",
			border: "1px solid #dbe7f5",
			borderRadius: "16px",
			padding: "16px",
			marginBottom: "14px",
			boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
		},
		addBtn: {
			border: "none",
			background: "#0f766e",
			color: "#fff",
			borderRadius: "999px",
			padding: "12px 18px",
			fontWeight: "700",
			cursor: "pointer",
			marginTop: "8px",
		},
		removeBtn: {
			border: "none",
			background: "#dc2626",
			color: "#fff",
			borderRadius: "999px",
			padding: "10px 14px",
			fontWeight: "700",
			cursor: "pointer",
			width: "100%",
		},
		priceBox: {
			background: "linear-gradient(135deg, #ecfdf5, #f0fdf4)",
			border: "1px solid #bbf7d0",
			borderRadius: "16px",
			padding: "16px 18px",
			marginTop: "20px",
			color: "#166534",
		},
		priceLabel: {
			fontSize: "14px",
			fontWeight: "700",
			marginBottom: "6px",
		},
		priceValue: {
			fontSize: "1.6rem",
			fontWeight: "800",
			margin: 0,
			color: "#000",
		},
		priceNote: {
			marginTop: "6px",
			marginBottom: 0,
			fontSize: "13px",
			color: "#15803d",
		},
	};

	const getInputStyle = (fieldName, disabled = false) => ({
		...(fieldName === "additionalNotes" ? styles.textarea : styles.input),
		...(focusedField === fieldName ? styles.inputFocus : {}),
		...(disabled ? styles.disabledField : {}),
	});

	const getSelectStyle = (fieldName, disabled = false) => ({
		...styles.select,
		...(focusedField === fieldName ? styles.inputFocus : {}),
		...(disabled ? styles.disabledField : {}),
	});

	const handleInputChange = ({ target: { name, value } }) => {
		const cleanValue =
			name === "mobilenumber" ? value.replace(/\D/g, "").slice(0, 10) : value;

		setFormData((prev) => ({
			...prev,
			[name]: cleanValue,
			...(name === "city" ? { area: "" } : {}),
		}));
	};

	const handleSearchChange = ({ target: { name, value } }) => {
		setSearchCriteria((prev) => ({
			...prev,
			[name]: value,
			...(name === "city" ? { area: "" } : {}),
		}));
	};

	const handleFocus = (fieldName) => setFocusedField(fieldName);
	const handleBlur = () => setFocusedField("");

	const getAvailableServiceTypes = (currentRowId) => {
		const selectedValuesFromOtherRows = formData.selectedServices
			.filter((item) => item.id !== currentRowId)
			.map((item) => item.service_type)
			.filter(Boolean);

		return serviceTypes.filter(
			(type) => !selectedValuesFromOtherRows.includes(type.value)
		);
	};

	const selectedServiceDetails = useMemo(() => {
		return formData.selectedServices
			.filter((item) => item.service_type)
			.map((item) => {
				const matched = serviceTypes.find((type) => type.value === item.service_type);
				const unitPrice = matched?.price ?? 0;
				const unit = matched?.unit ?? "job";
				const label = matched?.label ?? item.service_type;
				const limit = matched?.limit ?? null;
				const quantity = Number(item.quantity) || 1;
				const lineTotal = unitPrice * quantity;

				return {
					...item,
					service_label: label,
					unit_price: unitPrice,
					unit,
					limit,
					line_total: lineTotal,
				};
			});
	}, [formData.selectedServices, serviceTypes]);

	const grandTotal = selectedServiceDetails.reduce(
		(sum, item) => sum + item.line_total,
		0
	);

	const canAddMoreServices =
		formData.selectedServices.filter((item) => item.service_type).length < serviceTypes.length;

	const handleServiceRowChange = (id, field, value) => {
		setFormData((prev) => ({
			...prev,
			selectedServices: prev.selectedServices.map((item) => {
				if (item.id !== id) return item;

				if (field === "service_type") {
					const duplicateExists = prev.selectedServices.some(
						(row) =>
							row.id !== id &&
							row.service_type &&
							row.service_type === value
					);

					if (duplicateExists) {
						alert("This handling work is already added.");
						return item;
					}

					const selectedType = serviceTypes.find((type) => type.value === value);
					const limit = selectedType?.limit ?? 1;

					return {
						...item,
						service_type: value,
						quantity: Math.min(item.quantity || 1, limit),
					};
				}

				if (field === "quantity") {
					const selectedType = serviceTypes.find(
						(type) => type.value === item.service_type
					);
					const maxLimit = selectedType?.limit ?? 999;
					const qty = Math.max(1, Math.min(Number(value) || 1, maxLimit));

					return {
						...item,
						quantity: qty,
					};
				}

				return {
					...item,
					[field]: value,
				};
			}),
		}));
	};

	const addServiceRow = () => {
		const selectedValues = formData.selectedServices
			.map((item) => item.service_type)
			.filter(Boolean);

		if (selectedValues.length >= serviceTypes.length) {
			alert("All available handling works are already added");
			return;
		}

		setFormData((prev) => ({
			...prev,
			selectedServices: [
				...prev.selectedServices,
				{
					id: Date.now(),
					service_type: "",
					quantity: 1,
				},
			],
		}));
	};

	const removeServiceRow = (id) => {
		setFormData((prev) => ({
			...prev,
			selectedServices:
				prev.selectedServices.length === 1
					? prev.selectedServices
					: prev.selectedServices.filter((item) => item.id !== id),
		}));
	};

	const handleSearchCheckLabour = async (e) => {
		e.preventDefault();

		if (!searchCriteria.gender || !searchCriteria.city || !searchCriteria.area) {
			alert("Please fill all fields before searching");
			return;
		}

		try {
			setIsSearching(true);

			const response = await fetch(`${BASE_URL}/api/search/labour-cleaner/`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					...searchCriteria,
					work_category: "cleaner",
					service_category: categoryKey,
					service: serviceKey,
				}),
			});

			const data = await response.json();

			if (response.ok) {
				navigate("/labour-list", {
					state: {
						labours: data.labours,
						work_category: "Cleaner",
					},
				});
			} else {
				alert(data.error || "Failed to search labour.");
			}
		} catch (error) {
			console.error("Request failed:", error);
			alert("Request failed while searching labour.");
		} finally {
			setIsSearching(false);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const validServices = formData.selectedServices.filter((item) => item.service_type);

		if (validServices.length === 0) {
			alert("Please add at least one handling work");
			return;
		}

		try {
			setIsSubmitting(true);

			const requestBody = {
				...formData,
				service_category: categoryKey,
				selected_city: getUserCity(),
				service: serviceKey,
				handling: selectedServiceDetails.map((item) => item.service_label),
				selected_services: selectedServiceDetails,
				service_charge: grandTotal,
				category_label: categoryLabel,
				service_label: serviceLabel,
			};

			const response = await axios.post(
				`${BASE_URL}/api/requirements/cleaner/`,
				requestBody,
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setSuccessMessage("We will get back to you shortly. Thank you for contacting us.");
				setTimeout(() => {
					navigate("/");
				}, 1500);
			}
		} catch (error) {
			console.error("Error submitting form:", error);
			alert(error.response?.data?.error || "There was an error submitting your request.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div style={styles.page}>
			<div style={styles.wrapper}>
				<div style={styles.hero}>
					<div style={styles.heroBadge}>
						<FaBroom />
						{serviceLabel}
					</div>
					<h1 style={styles.heroTitle}>Hire or Search a Cleaner</h1>
					<p style={styles.heroText}>
						Post your cleaning requirement with selected handling works, timings,
						location, and pricing summary, or search available cleaners nearby.
					</p>
				</div>

				<div style={styles.switchWrap}>
					<button
						type="button"
						style={{
							...styles.switchBtn,
							...(activeForm === "post" ? styles.switchBtnActive : {}),
						}}
						onClick={() => setActiveForm("post")}
					>
						Post Your Requirement
					</button>
				</div>

				{activeForm === "post" ? (
					<form style={styles.formCard} onSubmit={handleSubmit}>
						<div style={styles.formHeader}>
							<h2 style={styles.formTitle}>Cleaner / Housekeeping Requirement Form</h2>
							<p style={styles.formSub}>
								Fill in your details, select required handling works, quantity, work time,
								and location details.
							</p>
						</div>

						<div style={styles.body}>
							{successMessage && (
								<div style={styles.successBox}>
									<FaCheckCircle />
									{successMessage}
								</div>
							)}

							<div style={styles.section}>
								<h3 style={styles.sectionTitle}>
									<FaUser />
									Personal Details
								</h3>

								<div style={styles.grid}>
									<div style={styles.field}>
										<label htmlFor="username" style={styles.label}>
											<FaUser /> Name
										</label>
										<input
											id="username"
											style={getInputStyle("username")}
											type="text"
											name="username"
											value={formData.username}
											onChange={handleInputChange}
											onFocus={() => handleFocus("username")}
											onBlur={handleBlur}
											required
										/>
									</div>

									<div style={styles.field}>
										<label htmlFor="mobilenumber" style={styles.label}>
											<FaPhoneAlt /> Mobile Number
										</label>
										<input
											id="mobilenumber"
											style={getInputStyle("mobilenumber")}
											type="tel"
											name="mobilenumber"
											value={formData.mobilenumber}
											onChange={handleInputChange}
											onFocus={() => handleFocus("mobilenumber")}
											onBlur={handleBlur}
											pattern="[0-9]{10}"
											maxLength={10}
											placeholder="Enter 10-digit mobile number"
											required
										/>
									</div>

									<div style={styles.field}>
										<label htmlFor="email" style={styles.label}>
											<FaEnvelope /> Email
										</label>
										<input
											id="email"
											style={getInputStyle("email")}
											type="email"
											name="email"
											value={formData.email}
											onChange={handleInputChange}
											onFocus={() => handleFocus("email")}
											onBlur={handleBlur}
											required
										/>
									</div>

									<div style={styles.field}>
										<label htmlFor="address" style={styles.label}>
											<FaMapMarkerAlt /> Address
										</label>
										<input
											id="address"
											style={getInputStyle("address")}
											type="text"
											name="address"
											value={formData.address}
											onChange={handleInputChange}
											onFocus={() => handleFocus("address")}
											onBlur={handleBlur}
											required
										/>
									</div>
								</div>
							</div>

							<div style={styles.section}>
								<h3 style={styles.sectionTitle}>
									<FaMapMarkerAlt />
									Housekeeping Preferences
								</h3>

								<div style={styles.grid}>
									<div style={styles.field}>
										<label htmlFor="city" style={styles.label}>
											<FaMapMarkerAlt /> City
										</label>
										<select
											id="city"
											style={getSelectStyle("city")}
											name="city"
											value={formData.city}
											onChange={handleInputChange}
											onFocus={() => handleFocus("city")}
											onBlur={handleBlur}
											required
										>
											<option value="">Select City</option>
											{Object.keys(areaOptions).map((city) => (
												<option key={city} value={city}>
													{city.charAt(0).toUpperCase() + city.slice(1)}
												</option>
											))}
										</select>
									</div>

									<div style={styles.field}>
										<label htmlFor="area" style={styles.label}>
											<FaMapMarkerAlt /> Area
										</label>
										<select
											id="area"
											style={getSelectStyle("area", !formData.city)}
											name="area"
											value={formData.area}
											onChange={handleInputChange}
											onFocus={() => handleFocus("area")}
											onBlur={handleBlur}
											required
											disabled={!formData.city}
										>
											<option value="">Select Area</option>
											{availableAreas.map((area) => (
												<option key={area} value={area}>
													{area}
												</option>
											))}
										</select>
									</div>

									<div style={styles.field}>
										<label htmlFor="language" style={styles.label}>
											<FaLanguage /> Preferred Language
										</label>
										<input
											id="language"
											style={getInputStyle("language")}
											type="text"
											name="language"
											placeholder="Hindi, English, Kannada etc"
											value={formData.language}
											onChange={handleInputChange}
											onFocus={() => handleFocus("language")}
											onBlur={handleBlur}
											required
										/>
									</div>

									<div style={styles.field}>
										<label htmlFor="gender" style={styles.label}>
											<FaUserTag /> Preferred Gender
										</label>
										<select
											id="gender"
											style={getSelectStyle("gender")}
											name="gender"
											value={formData.gender}
											onChange={handleInputChange}
											onFocus={() => handleFocus("gender")}
											onBlur={handleBlur}
											required
										>
											<option value="">Select</option>
											<option value="Male">Male</option>
											<option value="Female">Female</option>
											<option value="Others">Others</option>
										</select>
									</div>
								</div>
							</div>

							<div style={styles.section}>
								<h3 style={styles.sectionTitle}>
									<FaTools />
									Handling Works
								</h3>
								<p style={styles.helper}>
									Add one or more cleaning works from config and set quantity for each.
								</p>

								{formData.selectedServices.map((item, index) => {
									const matchedType = serviceTypes.find(
										(type) => type.value === item.service_type
									);
									const unitPrice = matchedType?.price ?? 0;
									const unit = matchedType?.unit ?? "job";
									const quantity = Number(item.quantity) || 1;
									const maxLimit = matchedType?.limit ?? 999;
									const lineTotal = unitPrice * quantity;

									return (
										<div key={item.id} style={styles.serviceCard}>
											<div style={styles.grid}>
												<div style={styles.field}>
													<label style={styles.label}>
														<FaBroom /> Handling Work {index + 1}
													</label>
													<select
														value={item.service_type}
														onChange={(e) =>
															handleServiceRowChange(item.id, "service_type", e.target.value)
														}
														style={styles.select}
														required
													>
														<option value="">Select Work Type</option>
														{getAvailableServiceTypes(item.id).map((type) => (
															<option key={type.value} value={type.value}>
																{type.label}
															</option>
														))}
													</select>
												</div>

												<div style={styles.field}>
													<label style={styles.label}>
														Quantity {matchedType ? `(${unit})` : ""}
													</label>
													<input
														type="number"
														min="1"
														max={maxLimit}
														value={item.quantity}
														onChange={(e) =>
															handleServiceRowChange(item.id, "quantity", e.target.value)
														}
														style={styles.input}
														disabled={!item.service_type}
													/>
												</div>

												<div style={styles.field}>
													<label style={styles.label}>Unit Price</label>
													<input
														type="text"
														value={unitPrice ? `₹ ${unitPrice}` : ""}
														readOnly
														style={styles.input}
													/>
												</div>

												<div style={styles.field}>
													<label style={styles.label}>Action</label>
													<button
														type="button"
														onClick={() => removeServiceRow(item.id)}
														style={styles.removeBtn}
														disabled={formData.selectedServices.length === 1}
													>
														<FaTrash className="me-2" />
														Remove
													</button>
												</div>
											</div>

											{matchedType && (
												<div style={{ marginTop: "12px", color: "#334155", fontSize: "14px" }}>
													<strong>{matchedType.label}</strong> — {quantity} {unit}
													{quantity > 1 ? "s" : ""} × ₹ {unitPrice} ={" "}
													<strong>₹ {lineTotal}</strong>
												</div>
											)}
										</div>
									);
								})}

								<button
									type="button"
									style={{
										...styles.addBtn,
										opacity: canAddMoreServices ? 1 : 0.6,
										cursor: canAddMoreServices ? "pointer" : "not-allowed",
									}}
									onClick={addServiceRow}
									disabled={!canAddMoreServices}
								>
									<FaPlus className="me-2" />
									Add Another Work
								</button>

								{selectedServiceDetails.length > 0 && (
									<div style={styles.priceBox}>
										<div style={styles.priceLabel}>Booking Summary</div>

										{selectedServiceDetails.map((item) => (
											<div key={item.id} style={{ marginBottom: "8px", color: "#000" }}>
												{item.service_label} - {item.quantity} {item.unit}
												{item.quantity > 1 ? "s" : ""} × ₹ {item.unit_price} = ₹ {item.line_total}
											</div>
										))}

										<p style={styles.priceValue}>Total: ₹ {grandTotal}</p>
										<p style={styles.priceNote}>
											Total charge based on selected handling works
										</p>
									</div>
								)}
							</div>

							<div style={styles.section}>
								<h3 style={styles.sectionTitle}>
									<FaCalendarCheck />
									Service Requirements
								</h3>

								<div style={styles.grid}>
									<div style={styles.field}>
										<label htmlFor="urgency" style={styles.label}>
											<FaClock /> Urgency
										</label>
										<select
											id="urgency"
											style={getSelectStyle("urgency")}
											name="urgency"
											value={formData.urgency}
											onChange={handleInputChange}
											onFocus={() => handleFocus("urgency")}
											onBlur={handleBlur}
											required
										>
											<option value="">Select</option>
											<option value="Urgent">Urgent</option>
											<option value="Within 1 Week">Within 1 Week</option>
											<option value="Just Enquiry">Just Enquiry</option>
										</select>
									</div>

									<div style={styles.field}>
										<label htmlFor="preferredworkTime" style={styles.label}>
											<FaClock /> Preferred Work Time
										</label>
										<select
											id="preferredworkTime"
											style={getSelectStyle("preferredworkTime")}
											name="preferredworkTime"
											value={formData.preferredworkTime}
											onChange={handleInputChange}
											onFocus={() => handleFocus("preferredworkTime")}
											onBlur={handleBlur}
											required
										>
											<option value="">Select</option>
											<option value="morning_shift">Morning - 6am to 10am</option>
											<option value="evening_shift">Evening - 5pm to 9pm</option>
											<option value="partial_shift">Partial 12hrs</option>
											<option value="full_shift">Full Time 24hrs</option>
										</select>
									</div>

									<div style={styles.field}>
										<label htmlFor="duration" style={styles.label}>
											<FaClock /> Duration
										</label>
										<input
											id="duration"
											style={getInputStyle("duration")}
											type="text"
											name="duration"
											placeholder="In months"
											value={formData.duration}
											onChange={handleInputChange}
											onFocus={() => handleFocus("duration")}
											onBlur={handleBlur}
											required
										/>
									</div>

									<div style={styles.field}>
										<label htmlFor="salaryOffered" style={styles.label}>
											<FaMoneyBillWave /> Salary Offer
										</label>
										<input
											id="salaryOffered"
											style={getInputStyle("salaryOffered")}
											type="text"
											name="salaryOffered"
											placeholder="Per month, e.g. 10000 rs/month"
											value={formData.salaryOffered}
											onChange={handleInputChange}
											onFocus={() => handleFocus("salaryOffered")}
											onBlur={handleBlur}
											required
										/>
									</div>

									<div style={styles.fullWidthField}>
										<label htmlFor="additionalNotes" style={styles.label}>
											<FaInfoCircle /> Additional Notes
										</label>
										<textarea
											id="additionalNotes"
											style={getInputStyle("additionalNotes")}
											name="additionalNotes"
											placeholder="Enter any specific requirements..."
											value={formData.additionalNotes}
											onChange={handleInputChange}
											onFocus={() => handleFocus("additionalNotes")}
											onBlur={handleBlur}
										/>
									</div>
								</div>
							</div>

							<div style={styles.submitWrap}>
								<button type="submit" style={styles.submitBtn} disabled={isSubmitting}>
									{isSubmitting ? "Submitting..." : "Submit Requirement"}
								</button>
							</div>
						</div>
					</form>
				) : (
					<form style={styles.formCard} onSubmit={handleSearchCheckLabour}>
						<div style={styles.formHeader}>
							<h2 style={styles.formTitle}>Search Cleaners</h2>
							<p style={styles.formSub}>
								Search available cleaners by gender, city, and area.
							</p>
						</div>

						<div style={styles.body}>
							<div style={styles.section}>
								<h3 style={styles.sectionTitle}>
									<FaMapMarkerAlt />
									Search Filters
								</h3>

								<div style={styles.grid}>
									<div style={styles.field}>
										<label htmlFor="search-gender" style={styles.label}>
											<FaUserTag /> Gender
										</label>
										<select
											id="search-gender"
											style={getSelectStyle("search-gender")}
											name="gender"
											value={searchCriteria.gender}
											onChange={handleSearchChange}
											onFocus={() => handleFocus("search-gender")}
											onBlur={handleBlur}
											required
										>
											<option value="">Select</option>
											<option value="Male">Male</option>
											<option value="Female">Female</option>
										</select>
									</div>

									<div style={styles.field}>
										<label htmlFor="search-city" style={styles.label}>
											<FaMapMarkerAlt /> City
										</label>
										<select
											id="search-city"
											style={getSelectStyle("search-city")}
											name="city"
											value={searchCriteria.city}
											onChange={handleSearchChange}
											onFocus={() => handleFocus("search-city")}
											onBlur={handleBlur}
											required
										>
											<option value="">Select City</option>
											{Object.keys(areaOptions).map((city) => (
												<option key={city} value={city}>
													{city.charAt(0).toUpperCase() + city.slice(1)}
												</option>
											))}
										</select>
									</div>

									<div style={styles.field}>
										<label htmlFor="search-area" style={styles.label}>
											<FaMapMarkerAlt /> Area
										</label>
										<select
											id="search-area"
											style={getSelectStyle("search-area", !searchCriteria.city)}
											name="area"
											value={searchCriteria.area}
											onChange={handleSearchChange}
											onFocus={() => handleFocus("search-area")}
											onBlur={handleBlur}
											required
											disabled={!searchCriteria.city}
										>
											<option value="">Select Area</option>
											{searchAreas.map((area) => (
												<option key={area} value={area}>
													{area}
												</option>
											))}
										</select>
									</div>
								</div>

								<div style={styles.submitWrap}>
									<button type="submit" style={styles.submitBtn} disabled={isSearching}>
										{isSearching ? "Searching..." : "Search Labour"}
									</button>
								</div>
							</div>
						</div>
					</form>
				)}
			</div>
		</div>
	);
};

export default Cleaner;